<div class="inner-tabs-cont mt-4">
        <ul class="nav nav-tabs inner-flight-search align-items-center btn-group" btnRadioGroup>
            <li class="nav-item one-way-search-tab" btnRadio="oneWay" [(ngModel)]="isRadioActive"
                [ngClass]="{'active': isRadioActive}" [class.active]="isOneWayActive" (click)="resetMultiCity('oneWay')" id="one-way-tab">
                <a class="nav-link">{{"One Way" | translate}}</a>
            </li>
            <li class="nav-item round-trip-search-tab" btnRadio="roundTrip" [(ngModel)]="isRoundTripActive"
            [ngClass]="{'active': isRoundTripActive}" [class.active]="isRoundTripActive" (click)="resetMultiCity('roundTrip')" id="round-trip-tab">
                <a class="nav-link">{{"Round Trip" | translate}}</a>
            </li>
            <li class="nav-item multi-city-search-tab" btnRadio="multiCity"
            [ngClass]="{'active': isMultiCityActive}" [class.active]="isMultiCityActive" [(ngModel)]="isMultiCityActive" (click)="addSingleMultiCity('multiCity')" id="multi-city-tab">
                <a class="nav-link">{{"Multi City" | translate}}</a>
            </li>
        </ul>
    <div class="flights-direct-opts">
        <span class="me-4">
            <input id="cbx1" type="checkbox" [(ngModel)]="isDirect" class="cbx" checked />
            <label for="cbx1" class="lbl">{{"Direct flights only" | translate}}</label>
        </span>
        <span>
            <input id="cbx2" type="checkbox" [(ngModel)]="isBaggage" class="cbx" />
            <label for="cbx2" class="lbl">{{"Including travel baggage" | translate}}</label>
        </span>
    </div>
</div>
<div class="tab-content search-bx-field-dtls">
    <div class="tab-pane fade show active">
        <form [formGroup]="flightSearch" (ngSubmit)="redirectToFlightList(flightSearch)" novalidate>
            <div class="one-way-flight-search round-trip-search d-flex">
                <div class="from-to-city">
                    <div class="from-city-name form-input mb-1">
                        <ng-template #customItemTemplate let-model="item" let-index="index">
                            <div class="location-info" [ngClass]="{'rtl-text': isRtl}">
                                <h5>{{ (isRtl && model.city_ar) ? model.city_ar : model.city_en }},
                                    {{ (isRtl && model.country_ar) ? model.country_ar :
                                    model.country_en }}
                                    <p>{{ (isRtl && model.airport_ar) ? model.airport_ar :
                                        model.airport_en }}</p>
                                </h5>
                                <span>{{ (isRtl && model.airport_code_ar) ? model.airport_code_ar :
                                    model.airport_code }}</span>
                            </div>
                        </ng-template>
                        <input formControlName="fromAirport"
                            [typeaheadAsync]="true" [typeahead]="getSearchAirport(flightSearch.get('fromAirport')?.value)"
                            [typeaheadItemTemplate]="customItemTemplate"
                            [typeaheadScrollable]="true" [typeaheadOptionsInScrollableView]="5"
                            [typeaheadOptionField]="isRtl ? 'display_name_ar' : 'display_name_en'"
                            [typeaheadGroupField]="isRtl ? 'city_ar' : 'city_en'"
                            [typeaheadMinLength]="3" (typeaheadOnSelect)="setFromLocation($event)"
                            (typeaheadNoResults)="fromAirportNoResults($event)"
                            placeholder="{{ 'Choose a travel destination' | translate }}"
                            class="form-control"
                            [ngClass]="{'error-input' : submitted && f['fromAirport'].errors}"
                            [class.valid]="flightSearch.get('fromAirport')?.valid &&
(flightSearch.get('toDo')?.dirty || flightSearch.get('fromAirport')?.touched)" [class.invalid]="flightSearch.get('toDo')?.invalid &&
(flightSearch.get('toDo')?.dirty || flightSearch.get('fromAirport')?.touched)">

                        <label for="">{{"From" | translate}}</label>

                        <div class="input-error up-side-error"
                            *ngIf="submitted && f['fromAirport'].errors">
                            <div *ngIf="f['fromAirport'].errors['required']"><i
                                    class="fa-solid fa-circle-exclamation"></i> {{'From Location is required' | translate}}.</div>
                            <div *ngIf="f['fromAirport'].errors['incorrect']"><i
                                    class="fa-solid fa-circle-exclamation"></i> {{'Departure must be different from arrival' | translate}}</div>
                        </div>
                        <div class="alert alert-danger" *ngIf="fromAirportNoResult">No Results Found
                        </div>
                        <!-- <div class="error-field" *ngIf="flightSearch.controls[fromLocation].invalid && flightSearch.controls[fromLocation].dirty">
                        <span *ngIf="flightSearch.controls[fromLocation].errors.required">This field is required</span>
                    </div> -->
                    </div>
                    <div class="switch-city-opt" (click)="switchLocation()">
                        <img src="assets/image/search/city-switch.png" alt="">
                    </div>
                    <div class="to-city-name form-input">
                        <ng-template #customItemTemplate let-model="item" let-index="index">
                            <div class="location-info" [ngClass]="{'rtl-text': isRtl}">
                                <h5>{{ (isRtl && model.city_ar) ? model.city_ar : model.city_en }}
                                    <p>{{ (isRtl && model.airport_ar) ? model.airport_ar :
                                        model.airport_en }}</p>
                                </h5>
                                <span>{{ (isRtl && model.airport_code_ar) ? model.airport_code_ar :
                                    model.airport_code }}</span>
                            </div>
                        </ng-template>
                        <input formControlName="toAirport"
                            [typeaheadAsync]="true" [typeahead]="getSearchAirport(flightSearch.get('toAirport')?.value)"
                            [typeaheadMultipleSearch]="true" typeaheadMultipleSearchDelimiters=",|"
                            [typeaheadItemTemplate]="customItemTemplate"
                            [typeaheadScrollable]="true" [typeaheadOptionsInScrollableView]="5"
                            [typeaheadOptionField]="isRtl ? 'display_name_ar' : 'display_name_en'"
                            [typeaheadGroupField]="isRtl ? 'city_ar' : 'city_en'"
                            [typeaheadMinLength]="3" (typeaheadOnSelect)="setToLocation($event)"
                            [ngClass]="{'error-input' : submitted && f['toAirport'].errors}"
                            (typeaheadNoResults)="toAirportNoResults($event)"
                            placeholder="{{'Choose destination' | translate}}" class="form-control">
                        <label for="">{{"To" | translate}}</label>
                        <div class="input-error" *ngIf="submitted && f['toAirport'].errors">
                            <div *ngIf="f['toAirport'].errors['required']"><i
                                    class="fa-solid fa-circle-exclamation"></i> {{'To Location is required' | translate}}</div>
                            <div *ngIf="f['toAirport'].errors['incorrect']"><i
                                    class="fa-solid fa-circle-exclamation"></i> {{'Arrival must be different from departure' | translate}}</div>
                        </div>
                        <div class="alert alert-danger" *ngIf="toAirportNoResult">No Results Found
                        </div>
                    </div>
                </div>
                <div class="departure-date">
                    <div class="depart-date position-relative mb-1"
                        [ngClass]="{'only-departure-time': isRadioActive || isMultiCityActive}">
                        <input type="text" class="form-control form-input"
                            formControlName="departureDate"
                            [readonly]="true" #dpDeparture="bsDatepicker"
                            [minDate]="minDate" [maxDate]="maxDate"
                            placeholder="{{ 'Departure Date' | translate }}" [bsConfig]="bsConfig"
                            (ngModelChange)="updateReturnDate()" bsDatepicker>
                        <label for="" (click)="dpDeparture.toggle()"><img
                                src="assets/image/search/calender.png" alt=""></label>
                    </div>
                    <div class="depart-date return-date-field position-relative"
                        *ngIf="!isRadioActive && !isMultiCityActive">
                        <div class="depart-date return-date-field position-relative"
                            [ngClass]="{'hidden': isRadioActive || isMultiCityActive}">
                            <input type="text" class="form-control form-input"
                                formControlName="returnDate"
                                [readonly]="true" #dpReturn="bsDatepicker"
                                [minDate]="returnDateMinimum" [maxDate]="maxDate"
                                placeholder="{{'Return Date' | translate}}" [bsConfig]="bsConfig"
                                bsDatepicker>
                            <label for="" (click)="dpReturn.toggle()"><img
                                    src="assets/image/search/calender.png" alt=""></label>
                        </div>
                        <label for="" (click)="dpReturn.toggle()"><img
                                src="assets/image/search/calender.png" alt=""></label>
                    </div>
                </div>
                <div class="travellers-info">
                    <div class="input-group w-auto align-items-center mb-1">
                        <button type="button" (click)="decrementAdult()"
                            class="button-minus border icon-shape icon-sm mx-1">-</button>
                        <input type="number" [(ngModel)]="adultCount" [value]="adultCount"
                            class="quantity-field border-0 text-center w-25"
                            placeholder="{{'Adult' | translate}} (12+)"
                            title="{{'Adult' | translate}} (12+)" (keyup)="incrementAdultText()"
                            [ngModelOptions]="{standalone: true}">
                        <button type="button" (click)="incrementAdult()"
                            class="button-plus border icon-shape icon-sm">+</button>
                    </div>
                    <div class="input-group w-auto align-items-center">
                        <button type="button" (click)="decrementInfant()"
                            class="button-minus border icon-shape icon-sm mx-1">-</button>
                        <input [(ngModel)]="infantCount" [ngModelOptions]="{standalone: true}"
                            type="number" (keyup)="incrementInfantText()"
                            class="quantity-field border-0 text-center w-25"
                            placeholder="{{'Infant (2-)' | translate}}">
                        <button type="button" (click)="incrementInfant()"
                            class="button-plus border icon-shape icon-sm">+</button>

                    </div>
                </div>
                <div class="travellers-info">
                    <div class="input-group w-auto align-items-center">
                        <button type="button" (click)="decrementChild();"
                            class="button-minus border icon-shape icon-sm mx-1">-</button>
                        <input [(ngModel)]="childCount" type="number"
                            class="quantity-field border-0 text-center w-25"
                            placeholder="{{'Child (2-12)' | translate}}"
                            [ngModelOptions]="{standalone: true}" (keyup)="incrementChildText()">
                        <button type="button" (click)="incrementChild();"
                            class="button-plus border icon-shape icon-sm">+</button>

                    </div>
                    <div class="class-selection">
                        <div class="selected-class" (click)="dropdownOpen()">
                            {{selectedTravelClass | translate}}
                            <img src="assets/image/red-down.png" width="10" class="mx-1"
                                alt="">
                        </div>
                        <div class="class-content" *ngIf="contentdropdown">
                            <ul>
                                <li *ngFor="let arr of travelClass; index as i"
                                    [class.active]="i === colorvariable"
                                    (click)="changeCode(arr); dropdownOpen()">
                                    <b>{{arr.displayName | translate}}</b>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
                <div class="search-btn">
                    <!-- <button type="submit" [disabled]="flightSearch.invalid"><img src="assets/image/search/search-ico.png" alt="">{{"Search" | translate}}</button> -->
                    <button type="submit"><img src="assets/image/search/search-ico.png"
                            alt="">{{"Search" | translate}}</button>
                </div>

            </div>
        </form>
            <div class="multi-city-search" *ngIf="isMultiCityActive">
                <form [formGroup]="multiCityForm">
                    <div formArrayName="multiCityArray" class="w-full">
                        <div *ngFor="let control of multiCityArray.controls; let i = index" [formGroupName]="i"
                            class="single-city-data element">
                            <h4>
                                <img *ngIf="i > 0" (click)="removeMultiCity(i)" class="remove"
                                    src="assets/image/search/close.png" alt="">
                                {{ "Flight" | translate }} {{ i + 2 }}
                            </h4>
                            <div class="d-flex">
                                <div class="from-to-city">{{control.get('fromAirport')?.value}}
                                    <div class="from-city-name form-input mb-1">
                                        <input formControlName="fromAirport"
                                            [typeaheadAsync]="true"
                                            [typeahead]="getSearchAirport(control.get('fromAirport')?.value)"
                                            [typeaheadItemTemplate]="customItemTemplate"
                                            [typeaheadOptionField]="isRtl ? 'display_name_ar' : 'display_name_en'"
                                            [typeaheadGroupField]="isRtl ? 'city_ar' : 'city_en'"
                                            [typeaheadOptionsLimit]="50" [typeaheadMinLength]="3"
                                            [typeaheadScrollable]="true" [typeaheadOptionsInScrollableView]="5"
                                            (typeaheadOnSelect)="setMultiFromLocation($event,i,'from')"
                                            (typeaheadNoResults)="fromMultiAirportNoResults($event, i)"
                                            placeholder="{{'Choose a travel destination' | translate}}"
                                            class="form-control"
                                            [ngClass]="{'error-input' : submitted && control.get('fromAirport')?.errors}">
                                        <label for="">{{"From" | translate}}</label>
                                        <div class="input-error up-side-error"
                                            *ngIf="submitted && control.get('fromAirport')?.errors">
                                            <div
                                                *ngIf="control.get('fromAirport')?.hasError('required')">
                                                <i class="fa-solid fa-circle-exclamation"></i> {{'From Location is required' | translate}}</div>
                                            <div
                                                *ngIf="control.get('fromAirport')?.hasError('incorrect')">
                                                <i class="fa-solid fa-circle-exclamation"></i> {{'Departure must be different from arrival' | translate}}</div>
                                        </div>
                                        <div class="alert alert-danger" *ngIf="fromMultiAirportNoResult[i]">
                                            {{'No Results Found' | translate}}</div>
                                    </div>
                                    <div class="switch-city-opt" (click)="switchLocationMulticity(i)">
                                        <img src="assets/image/search/city-switch.png" alt="">
                                    </div>
                                    <div class="to-city-name form-input">
                                        <input formControlName="toAirport"
                                            [typeaheadAsync]="true"
                                            [typeahead]="getSearchAirport(control.get('toAirport')?.value)"
                                            [typeaheadOptionsLimit]="50"
                                            [typeaheadScrollable]="true" [typeaheadOptionsInScrollableView]="5"
                                            [typeaheadItemTemplate]="customItemTemplate"
                                            [typeaheadOptionField]="isRtl ? 'display_name_ar' : 'display_name_en'"
                                            [typeaheadGroupField]="isRtl ? 'city_ar' : 'city_en'"
                                            [typeaheadMinLength]="3"
                                            (typeaheadOnSelect)="setMultiFromLocation($event,i,'to')"
                                            (typeaheadNoResults)="toMultiAirportNoResults($event, i)"
                                            placeholder="{{'Choose destination' | translate}}"
                                            class="form-control"
                                            [ngClass]="{'error-input' : submitted && control.get('toAirport')?.errors}">
                                        <label for="">{{"To" | translate}}</label>
                                        <div class="input-error"
                                            *ngIf="submitted && control.get('toAirport')?.errors">
                                            <div
                                                *ngIf="control.get('toAirport')?.hasError('required')">
                                                <i class="fa-solid fa-circle-exclamation"></i> {{'To Location is required' | translate}}</div>
                                        </div>
                                        <div class="alert alert-danger" *ngIf="toMultiAirportNoResult[i]">{{'No Results Found' | translate}}</div>
                                    </div>
                                </div>
                                <div class="departure-date">
                                    <!-- (bsValueChange)="onValueChangeMulti($event,i)" -->
                                    <div class="depart-date position-relative mb-1"
                                        [ngClass]="{'only-departure-time': isRadioActive || isMultiCityActive}">
                                        <input type="text" class="form-control form-input"
                                            formControlName="departureDate"
                                            [readonly]="true"
                                            #dpDeparture="bsDatepicker"
                                            [bsValue]="control.get('departureDate')?.value"
                                            [minDate]="calculateMinDateMulti(i)" [maxDate]="maxDate"
                                            placeholder="{{'Departure Date' | translate}}"
                                            [bsConfig]="bsConfig"
                                            [ngClass]="{'error-input' : submitted && control.get('departureDate')?.errors}"
                                            bsDatepicker>
                                        <label for="" (click)="dpDeparture.toggle()"><img
                                                src="assets/image/search/calender.png" alt=""></label>
                                        <div class="input-error up-side-error"
                                            *ngIf="submitted && control.get('departureDate')?.errors">
                                            <div><i class="fa-solid fa-circle-exclamation"></i> {{'Departure date is required' | translate}}</div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </form>
                <div *ngIf="showAddButton" class="add-new-flight-opt add" (click)="addMultiCity()">
                    <img src="assets/image/search/add.png" width="20" height="20" alt="">
                    {{"Add another flight?" | translate}}
                </div>
            </div>
        
        <div class="multi-city-search" [ngClass]="{'hidden': !isMultiCityActive}">
            <div class="single-city-data element" style="display: none;">
                <h4>{{"Flight 2" | translate}}</h4>
                <!-- <form [formGroup]="flightSearch" (ngSubmit)="redirectToFlightList(flightSearch)" novalidate> -->
                <div class="from-to-city">
                    <div class="from-city-name form-input mb-1">
                        <input formControlName="fromLocation" [typeahead]="FromAirportDataSource"
                            [typeaheadOptionsLimit]="50" [typeaheadMinLength]="0"
                            placeholder="{{'Select From City' | translate}}" class="form-control"
                            [ngClass]="{'error-input' : submitted && f['fromLocation'].errors}">
                        <label for="">{{"From" | translate}}</label>
                        <div class="input-error up-side-error"
                            *ngIf="submitted && f['fromLocation'].errors">
                            <div *ngIf="f['fromLocation'].errors['required']"><i
                                    class="fa-solid fa-circle-exclamation"></i> {{'From Location is required' | translate}}</div>
                        </div>
                    </div>
                    <div class="switch-city-opt">
                        <img src="assets/image/search/city-switch.png" alt="">
                    </div>
                    <div class="to-city-name form-input">
                        <input formControlName="toLocation" [typeahead]="ToAirportDataSource"
                            [typeaheadOptionsLimit]="50" [typeaheadMinLength]="0"
                            placeholder="{{'Select To City' | translate}}" class="form-control"
                            [ngClass]="{'error-input' : submitted && f['fromLocation'].errors}">
                        <label for="">{{"To" | translate}}</label>
                        <div class="input-error" *ngIf="submitted && f['toLocation'].errors">
                            <div *ngIf="f['toLocation'].errors['required']"><i
                                    class="fa-solid fa-circle-exclamation"></i> {{'To Location is required.' | translate}}</div>
                        </div>
                    </div>
                </div>
                <div class="departure-date">
                    <!-- <form *ngIf="myDatepicker" [formGroup]="myDatepicker" class="flex-column"> -->
                    <div class="depart-date position-relative mb-1"
                        [ngClass]="{'only-departure-time': isRadioActive || isMultiCityActive}">
                        <input type="text" class="form-control form-input" formControlName="dateYMD"
                            [(ngModel)]="bsRangeValue" [minDate]="minDate" [maxDate]="maxDate"
                            placeholder="{{'Departure Date' | translate}}" [bsConfig]="bsConfig"
                            bsDatepicker>
                        <label for=""><img src="assets/image/search/calender.png" alt=""></label>
                    </div>
                    <!-- </form> -->
                </div>
                <div class="add-new-flight-opt add" (click)="addDiv()">
                    <img src="assets/image/search/add.png" width="20" height="20" alt="">
                    {{"Add another flight?" | translate}}
                </div>
                <!-- </form> -->
            </div>
            <div class="more-citys-list" style="display: none;">
                <div *ngFor="let div of dynamicDivs; trackBy: trackByFn; let i = index">
                    <div class="single-city-data element">
                        <h4><img (click)="removeDiv(i)" class="remove"
                                src="assets/image/search/close.png" alt="">Flight {{ i + 3 }}</h4>
                        <!-- <form [formGroup]="flightSearch" (ngSubmit)="redirectToFlightList(flightSearch)" novalidate>  -->
                        <div class="from-to-city">
                            <div class="from-city-name form-input mb-1">
                                <input formControlName="fromLocation"
                                    [typeahead]="FromAirportDataSource" [typeaheadOptionsLimit]="50"
                                    [typeaheadMinLength]="0"
                                    placeholder="{{'Select From City' | translate}}"
                                    class="form-control"
                                    [ngClass]="{'error-input' : submitted && f['fromLocation'].errors}">
                                <label for="">{{"From" | translate}}</label>
                                <div class="input-error up-side-error"
                                    *ngIf="submitted && f['fromLocation'].errors">
                                    <div *ngIf="f['fromLocation'].errors['required']"><i
                                            class="fa-solid fa-circle-exclamation"></i> From
                                        Location is required.</div>
                                </div>
                            </div>
                            <div class="switch-city-opt">
                                <img src="assets/image/search/city-switch.png" alt="">
                            </div>
                            <div class="to-city-name form-input">
                                <input formControlName="toLocation"
                                    [typeahead]="ToAirportDataSource" [typeaheadOptionsLimit]="50"
                                    [typeaheadMinLength]="0"
                                    placeholder="{{'Select To City' | translate}}"
                                    class="form-control"
                                    [ngClass]="{'error-input' : submitted && f['fromLocation'].errors}">
                                <label for="">{{"To" | translate}}</label>
                                <div class="input-error"
                                    *ngIf="submitted && f['toLocation'].errors">
                                    <div *ngIf="f['toLocation'].errors['required']"><i
                                            class="fa-solid fa-circle-exclamation"></i> To Location
                                        is required.</div>
                                </div>
                            </div>
                        </div>
                        <div class="departure-date">
                            <!-- <form *ngIf="myDatepicker" [formGroup]="myDatepicker" class="flex-column"> -->
                            <div class="depart-date position-relative mb-1"
                                [ngClass]="{'only-departure-time': isRadioActive || isMultiCityActive}">
                                <input type="text" class="form-control form-input"
                                    formControlName="dateYMD" [maxDate]="maxDate"
                                    [(ngModel)]="bsRangeValue"
                                    placeholder="{{'Departure Date' | translate}}"
                                    [bsConfig]="{ dateInputFormat: 'DD-MM-YYYY', containerClass: 'theme-red', showWeekNumbers: false  }"
                                    bsDatepicker>
                                <label for=""><img src="assets/image/search/calender.png"
                                        alt=""></label>
                            </div>
                            <!-- </form> -->
                        </div>
                        <!-- </form> -->
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
